module.exports = __webpack_public_path__ + "img/IMG_5615_P-2_L_WoodMatted.079d09cd.jpg";